<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_AddKeyword')"
    append-to-body
    :close-on-click-modal="false"
    width="400px"
  >
    <el-form label-width="100px">
      <el-form-item>
        <span slot="label"><i style="color: red;">*</i>{{ $t('Information.SensitiveWords') }}</span>
        <el-input ref="words" v-model="form.words" no="words" @change=" value => thresholdLength = value.replace(/\s+/g, '').length - 1" />
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_ApplicationBranch1')">
        <cargo-multiple-select no="multipleBranchId" :value="toArray(form.multipleBranchId)" filterable clearable style="width: 100%;" @input="onMultipleBranchIdInput">
          <el-option :key="-1" :label="$t('Message.All')" value="0" />
          <el-option v-for="(item,index) in officeList" :key="index" :label="getOfficeLabel(item)" :value="String(item.officeId)" />
        </cargo-multiple-select>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_BusinessType')">
        <cargo-multiple-select no="multipleLob" :value="toArray(form.multipleLob)" filterable clearable style="width: 100%;" @input="onMultipleLobInput">
          <el-option v-for="(item,index) in lobs" :key="index" :label="$selectByLang(item.chineseName,item.englishName)" :value="item.code" />
        </cargo-multiple-select>
      </el-form-item>
      <el-form-item :label="$t('Information.SeaAirRoutes')">
        <cargo-multiple-select no="multipleRegion" :disabled="!isSea&&!isAir" :value="toArray(form.multipleRegion)" filterable clearable style="width: 100%;" @input="onMultipleRegionInput">
          <el-option :key="-1" :label="$t('Message.All')" value=" " />
          <el-option v-for="(item,index) in regionList" :key="index" :label="$selectByLang(item.name,item.nameEnglish)" :value="item.code" />
        </cargo-multiple-select>
      </el-form-item>
      <el-form-item :label="$t('Information.AppliedSeaport')">
        <cargo-advance-select
          no="multipleSeaPort"
          :disabled="!isSea"
          filterable
          :select-type="TYPE_NAMES.basic_data_Seaport"
          :static-options="seaportList"
          :default-multiple-value="toArray(form.multipleSeaPort)"
          :multiple="true"
          @parentCallBack="onMultipleSeaPortInput"
        />
      </el-form-item>
      <el-form-item :label="$t('Information.AppliedShippingCompany')">
        <cargo-advance-select
          no="multipleSeaCmp"
          :disabled="!isSea"
          filterable
          :select-type="TYPE_NAMES.basic_data_Company"
          :static-options="seaCmpList"
          :default-multiple-value="toNumArray(form.multipleSeaCmp)"
          :multiple="true"
          @parentCallBack="onMultipleSeaCmpInput"
        />
      </el-form-item>
      <el-form-item :label="$t('Information.ApplicationAirport')">
        <cargo-advance-select
          no="multipleAirPort"
          :disabled="!isAir"
          filterable
          :select-type="TYPE_NAMES.basic_data_Airport"
          :static-options="airportList"
          :default-multiple-value="toArray(form.multipleAirPort)"
          :multiple="true"
          @parentCallBack="onMultipleAirPortInput"
        />
      </el-form-item>
      <el-form-item :label="$t('Information.AppliedAirlines')">
        <cargo-advance-select
          no="multipleAirCmp"
          :disabled="!isAir"
          filterable
          :select-type="TYPE_NAMES.basic_data_Company"
          :static-options="airCmpList"
          :default-multiple-value="toNumArray(form.multipleAirCmp)"
          :multiple="true"
          @parentCallBack="onMultipleAirCmpInput"
        />
      </el-form-item>
      <el-form-item>
        <template slot="label">
          <span>{{ $t('Information.Threshold') }}
            <el-tooltip
              class="item"
              :content="$t('Information.ThresholdTip')"
              placement="top"
              effect="light"
              style="color: #4AA4EA"
            >
              <i
                class="el-icon-question"
                style="font-size: 16px; vertical-align: middle;"
              />
            </el-tooltip>
          </span>
        </template>
        <el-input-number
          v-model="form.threshold"
          no="threshold"
          controls-position="right"
          :min="0"
          :max="thresholdLength"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" style="text-align: center;">
      <el-button type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      <el-button @click="closeHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import * as sensitiveWordApi from '@/api/basicData/sensitiveWord'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey, getFilterCacheList } from '@/utils/basicDataCache'
import { FBA_LOBS } from '@/class/cargo/model/parameters/SystemConstants'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoMultipleSelect from '@/components/Cargo/Common/CargoMultipleSelect'

export default {
  name: 'SensitiveAddDialog',
  components: { cargoAdvanceSelect, CargoMultipleSelect },
  props: {
    visible: { type: Boolean, required: true },
    wordField: { type: Number, required: true }
  },
  data() {
    const newForm = {
      words: '',
      wordField: 0,
      multipleBranchId: '0',
      multipleLob: 'ALL',
      multipleRegion: ' ',
      multipleSeaPort: ' ',
      multipleSeaCmp: '0',
      multipleAirPort: ' ',
      multipleAirCmp: '0',
      threshold: 0
    }
    return {
      innerVisible: false,
      TYPE_NAMES,
      officeList: [],
      officeConfigLabel: '',
      lobs: [{ code: 'ALL', chineseName: this.$t('Message.All'), englishName: this.$t('Message.All') }, ...FBA_LOBS],
      regionList: [],
      seaportList: [],
      seaCmpList: [],
      airportList: [],
      airCmpList: [],
      newForm,
      form: newForm,
      thresholdLength: 0
    }
  },
  computed: {
    isSea() {
      const lobs = this.toArray(this.form.multipleLob)
      return lobs.includes('ALL') || lobs.includes('SE') || lobs.includes('SI') || lobs.includes('FBA_SE')
    },
    isAir() {
      const lobs = this.toArray(this.form.multipleLob)
      return lobs.includes('ALL') || lobs.includes('AE') || lobs.includes('AI') || lobs.includes('FBA_AE')
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.form = { ...this.newForm, wordField: this.wordField }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    const seaportAll = { code: ' ', chineseName: this.$t('Message.All'), englishName: this.$t('Message.All') }
    const cmpAll = { cmpIdx: 0, cnShortName: '', shortName: '', chineseName: this.$t('Message.All'), englishName: this.$t('Message.All') }
    this.officeList = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
    this.regionList = getCacheListByKey(basicCacheKeys.basic_data_Region)
    this.seaportList = [seaportAll, ...getCacheListByKey(basicCacheKeys.basic_data_Seaport)]
    this.seaCmpList = [cmpAll, ...getFilterCacheList(basicCacheKeys.basic_data_Company, item => item.seaCmp)]
    this.airportList = [seaportAll, ...getCacheListByKey(basicCacheKeys.basic_data_Airport)]
    this.airCmpList = [cmpAll, ...getFilterCacheList(basicCacheKeys.basic_data_Company, item => item.airCmp)]
    const configs = this.$store.state.settings.partnerLabelSettings
    const officeConfig = configs.find(config => config.autoKey === 'auto_office')
    this.officeConfigLabel = Object.keys(officeConfig).find(key => typeof officeConfig[key] === 'boolean' && officeConfig[key])
  },
  methods: {
    saveHandler() {
      if (!this.checkSensitiveWord()) {
        return
      }
      sensitiveWordApi.saveSensitiveWord(this.form).then(resp => {
        this.saveSensitiveWordHandler(resp)
      })
    },
    checkSensitiveWord() {
      if (!this.form.words.trim()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_KeyWordCanTBeEmpty'))
        this.$refs.words.focus()
        return false
      }
      return true
    },
    saveSensitiveWordHandler(resp) {
      const result = resp.data
      let count = 0
      let listTemp = []
      let wordsListTemp = []
      if (result) {
        count = result.count
        listTemp = result.listTemp
        wordsListTemp = result.wordsListTemp
      }
      if (count > 0) {
        // FlexGlobals.topLevelApplication.status = '保存成功.'
      }

      let copyWord = ''
      if (listTemp.length > 0) {
        copyWord = this.checkCopyWord(listTemp)
      }
      let copyWordQT = ''
      if (wordsListTemp.length > 0) {
        copyWordQT = this.checkCopyWord(wordsListTemp)
      }
      if (!copyWord && !copyWordQT) {
        this.$message.success(this.$t('Message.SaveSucceed'))
      } else {
        if (copyWord && !copyWordQT) {
          this.$message.success('保存成功,以下敏感词词库已存在，无需保存：\n' + copyWord)
        } else if (!copyWord && copyWordQT) {
          this.$message.success('保存成功,以下敏感词录入多次：\n' + copyWordQT)
        } else if (copyWord && copyWordQT) {
          this.$message.success('保存成功,以下敏感词词库已存在，无需保存：\n' + copyWord + '\n' + '以下敏感词录入多次：\n' + copyWordQT)
        }
      }
      this.$emit('refreshGrid')
      this.closeHandler()
    },
    checkCopyWord(arr) {
      let copyWord = ''
      if (arr.length > 0) {
        let f = false
        for (const w of arr) {
          if (arr.length === 1) {
            copyWord = w
          } else {
            copyWord += (',' + w)
            f = true
          }
        }
        if (f) {
          copyWord = copyWord.substring(1)
        }
      }
      return copyWord
    },
    closeHandler() {
      this.$emit('close')
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toArray(txt) {
      if (txt) {
        return txt.split(',')
      }
      return []
    },
    toTxt(strs) {
      if (strs && strs.length > 0) {
        return strs.join(',')
      }
      return ''
    },
    getOfficeLabel(item) {
      switch (this.officeConfigLabel) {
        case 'chineseName':
          return item.chineseName
        case 'englishName':
          return item.englishName
        default:
          return item.code
      }
    },
    handleAllItem(oldVal, val, allItem) {
      if (val && val.length > 0) {
        let diffItem = null
        for (const valItem of val) {
          if (!oldVal.includes(valItem)) {
            diffItem = valItem
            break
          }
        }
        if (diffItem || diffItem === 0) {
          if (diffItem === allItem) {
            val = [allItem]
          } else {
            val = val.filter(p => p !== allItem)
          }
        }
      }
      return val
    },
    onMultipleBranchIdInput(val) {
      val = this.handleAllItem(this.toArray(this.form.multipleBranchId), val, '0')
      this.form.multipleBranchId = this.toTxt(val)
    },
    onMultipleLobInput(val) {
      val = this.handleAllItem(this.toArray(this.form.multipleLob), val, 'ALL')
      this.form.multipleLob = this.toTxt(val)
    },
    onMultipleRegionInput(val) {
      val = this.handleAllItem(this.toArray(this.form.multipleRegion), val, ' ')
      this.form.multipleRegion = this.toTxt(val)
    },
    onMultipleSeaPortInput(data) {
      const val = this.handleAllItem(this.toArray(this.form.multipleSeaPort), data.value, ' ')
      this.form.multipleSeaPort = this.toTxt(val)
    },
    onMultipleSeaCmpInput(data) {
      const val = this.handleAllItem(this.toNumArray(this.form.multipleSeaCmp), data.value, 0)
      this.form.multipleSeaCmp = this.toTxt(val)
    },
    onMultipleAirPortInput(data) {
      const val = this.handleAllItem(this.toArray(this.form.multipleAirPort), data.value, ' ')
      this.form.multipleAirPort = this.toTxt(val)
    },
    onMultipleAirCmpInput(data) {
      const val = this.handleAllItem(this.toNumArray(this.form.multipleAirCmp), data.value, 0)
      this.form.multipleAirCmp = this.toTxt(val)
    }
  }
}
</script>

<style scoped>

</style>
